import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  searchMaskInput: {
    flex: 1,
    padding: '4px !important',
  },
  formButton: {
    borderRadius: 8,
    height: 60,
    width: 72,
    bottom: 10,
    [theme.breakpoints.down(769)]: {
      height: 58,
    },
    [theme.breakpoints.down(481)]: {
      height: 56,
    },
    [theme.breakpoints.down(376)]: {
      height: 54,
      width: 70,
    },
  },
  svg: {
    width: 30,
    height: 30,
  },
}));

export default useStyles;
